import PageHeader from '../../components/common/PageHeader';
import ItemLookupPanel from '../../components/common/ItemLookupPanel';

export default function ItemLookup() {
  return (
    <div>
      <PageHeader
        title="Item Lookup"
        subtitle="Pick one item to see it across every site at once — every serialized unit and who holds it, or aggregate stock and issued counts"
      />
      <ItemLookupPanel />
    </div>
  );
}
